<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="700px"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form
          :model="form"
          ref="form"
          label-width="120px"
          :rules="rules"
          :disabled="row.Id ? true : false"
        >
          <el-form-item label="设备名称" prop="DeviceItemNameJson">
            <div style="width: 100%; display: flex; align-items: center">
              <el-input
                v-model="form.DeviceItemNameJson"
                placeholder="请选择设备"
                disabled
                style="width: calc(100% - 60px)"
              ></el-input>
              <el-button
                style="width: 60px"
                type="primary"
                @click="openDevice"
                :disabled="dev.Id ? true : false"
                ><i class="el-icon-search"></i
              ></el-button>
            </div>
          </el-form-item>

          <el-form-item label="报废日期" prop="OperationDate">
            <el-date-picker
              v-model="form.OperationDate"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
              placeholder="请选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="报废描述" prop="Remarks">
            <el-input
              v-model="form.Remarks"
              placeholder=""
              type="textarea"
              rows="26"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit" v-if="!row.Id"
          >保存</el-button
        >
      </div>
    </el-drawer>
    <DevDialog
      ref="DevDialog"
      @select="handleDevSelect"
      type="radio"
    ></DevDialog>
  </div>
</template>
<script>
import Token from '@/utils/cache/TokenCache.js'
import DevDialog from '@/components/DevDialog/DevDialog.vue'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      title: '',
      moment,
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      RoleList: [],
      State: null,
      row: {},
      form: {
        DeviceItemNameJson: '',
        DeviceItemId: '',
        device_name: '',
        DeviceCode: '',
        Remarks: '',
        State: '',
        OperationDate: '',
      },
      Imgs: [],
      rules: {
        DeviceItemNameJson: [
          { required: true, message: '请选择设备', trigger: 'change' },
        ],
        State: [{ required: true, message: '请选择类型', trigger: 'change' }],
        OperationDate: [
          { required: true, message: '请选择报废日期', trigger: 'change' },
        ],
        Remarks: [
          { required: true, message: '请填写报废描述', trigger: 'blur' },
        ],
      },
      drawer: false,
      dev: {},
    }
  },
  props: {},
  components: { DevDialog },
  methods: {
    handlePictureCardPreview(file) {
      window.open(file.url)
    },
    handleDevSelect(arr) {
      console.log(arr)
      this.$set(this.form, 'DeviceItemId', arr[0].Id)
      this.$set(this.form, 'device_name', arr[0].device_name)
      this.$set(this.form, 'DeviceCode', arr[0].DeviceCode)
      this.$set(
        this.form,
        'DeviceItemNameJson',
        `${this.form.device_name}(${this.form.DeviceCode})`
      )
    },
    openDevice() {
      this.$refs.DevDialog.openDialog()
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res, file, fileList) {
      console.log(file, fileList)
      console.log(res)
      this.Imgs = [...fileList]
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
      this.Imgs = [...fileList]

      // this.Imgs = [...fileList];
    },
    handleExceed(files, fileList) {
      this.$notify.warning(`当前限制选择 9 个文件`)
    },
    getRoleList() {
      this.$http
        .post('/Base_Manage/Base_Role/GetDataList', {
          SortField: 'CreateTime',
          SortType: 'Desc',
        })
        .then((resJson) => {
          if (resJson.Success) {
            this.RoleList = resJson.Data
          }
        })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }

        this.loading = true

        this.$http
          .post('/PB/PB_Project/SaveDeviceState', {
            ...this.form,
            Type: 3,
            State: 3,
            Id: this.form.DeviceItemId,
          })
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}, dev) {
      this.drawer = true
      this.row = row
      this.form = {
        DeviceItemNameJson: '',
        DeviceItemId: '',
        device_name: '',
        DeviceCode: '',
        Remarks: '',
        State: '',
        OperationDate: '',
      }
      this.dev = dev || {}
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.$set(this.form, 'OperationDate', moment().format('YYYY-MM-DD'))

        if (dev) {
          this.$set(this.form, 'DeviceItemId', dev.Id)
          this.$set(this.form, 'device_name', dev.device_name)
          this.$set(this.form, 'DeviceCode', dev.DeviceCode)
          this.$set(
            this.form,
            'DeviceItemNameJson',
            `${this.form.device_name}(${this.form.DeviceCode})`
          )
        }
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_Scrap/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data || {}
            this.$set(
              this.form,
              'DeviceItemNameJson',
              `${this.form.device_name}(${this.form.DeviceCode})`
            )
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  overflow-y: auto;
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
